export var TopicStage;
(function (TopicStage) {
    TopicStage["Unspecified"] = "";
    TopicStage["Late"] = "Late";
    TopicStage["Early"] = "Early";
})(TopicStage || (TopicStage = {}));
export const topicStageOptions = ['Early', 'Late'].map((value) => ({
    value,
    label: value,
}));
//# sourceMappingURL=TopicStage.js.map